<template>
  <v-dialog
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
    scrollable
    max-width="500">
    <v-card>
      <v-app-bar flat dark color="primary">
        <v-toolbar-title>Dienstleistung löschen</v-toolbar-title>
      </v-app-bar>
      <v-card>
        <v-card-text>
          Sie möchten die Dienstleistung <b>{{service.name}}</b> wirklich löschen?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="$emit('close')"
          >
            Abbrechen
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            text
            @click="deleteService"
          >
            Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'DeleteServiceConfirmDialog',
    props: {
      show: {
        type: Boolean,
        default: false
      },
      service: {
        type: Object,
        default: function () {
          return {
            id: 0,
            name: ''
          }
        }
      }
    },
    methods: {
      deleteService () {
        this.$store.dispatch('deleteService', this.service.id)
          .finally(() => this.$emit('close'))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Services/DeleteServiceConfirmDialog.vue